import React from 'react';
import { translate } from '../../Services/translation';

const ComparisonPageButton = props => {
    const { count, href } = props;
    return (
        <div
            className={`cart cart--mini ${
                !count? 'hide-comparison' : ''
            }`}
        >
            <a className="button hollow" href={href}>
                <img src="/ui/images/switch.svg" alt="Comparison icon" />
                <span className="button-text text-light">
                    {translate('site.comparison')}
                </span>
                <span className="cart__quantity">{count}</span>
            </a>
            <span className="tooltiptext">{translate('tooltip.compare')}</span> 
        </div>
    );
};

export default ComparisonPageButton;
